import React, { useState, useEffect } from 'react';
import { Button, Space } from 'antd';
import { MinusOutlined, BuildOutlined, BarChartOutlined } from '@ant-design/icons';
import DreModal from '../../ModalDRE';
import LivroRazaoModal from '../../LivroRazao';
import EditLancamento from '../../EditarLancamento';
import LancamentosBancarios from '../../LancamentosBancarios';
import BalancoModal from '../../ModalBalancoPatrimonial';
import PagamentosModal from '../../Pagamentos';
import ModalContasContabeis from '../../ContaContabeis';
import ModalExcel from '../../ModalExcelLancamento';
import ModalDeletePeriod from '../../ModalDeletarPeriodo';
import ModalRegeneratePeriod from '../../ModalRegerarPeriodo';
import ModalBloquearPeriodo from '../../ModalBloqueioPeriodo';
import ModalRemoverBloqueio from '../../ModalDeletarBloqueioPeriodo';
import ModalZerarPeriodo from '../../ModalZeramento';
import ModalInforme from '../../ModalInforme';
import ModalExportarExcel from '../../ModalExportarExcel';
import ModalFaturamento from '../../ModalFaturamento';
import ModalFolha from '../../ModalFolha';
import ModalPatrimonio from '../../ModalPatrimonio';
import ContabilidadeDashboard from '../../Dashboard';
import { Modal } from 'antd';
import { useDraggableModal } from '../utils/modalDraggable';
import { CiSquareRemove } from "react-icons/ci";

export default function BalanceteModals({
    modals,
    minimized,
    toggleModal,
    minimizeModal,
    filterType,
    mesCompetencia,
    periodo,
    contaSelecionada,
    razaoAbertoPor,
    editingLancamentoId,
    periodoFechado,
    fetchBalancete,
    consultarPeriodoFechado,
    consultarMesesBloqueados,
    defisPendencia,
    situacaoList,
    faturamentoData,
    zIndices = {},
    focusModal
}) {
    // Estado para saber quais modais já foram montados ao menos uma vez
    const [mounted, setMounted] = useState({});

    useEffect(() => {
        const newMounted = { ...mounted };
        let changed = false;
        Object.keys(modals).forEach(key => {
            if (modals[key] && !mounted[key]) {
                newMounted[key] = true;
                changed = true;
            }
        });
        if (changed) setMounted(newMounted);
    }, [modals]);

    const wrapTitle = (title, key) => (
        <div className={`modal-drag-handle-${key}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
            <span>{title}</span>
            <Button
                type="text"
                size="small"
                icon={<MinusOutlined />}
                onClick={(e) => {
                    e.stopPropagation();
                    minimizeModal(key);
                }}
                style={{ marginLeft: 'auto', marginRight: 8 }}
            />
        </div>
    );

    return (
        <>
            {(modals.dre || mounted.dre) && (
                <DreModal
                    visible={modals.dre}
                    title={wrapTitle("DRE - Demonstração de Resultado do Exercício", 'dre')}
                    filterType={filterType}
                    mesCompetencia={mesCompetencia}
                    periodo={periodo}
                    onClose={() => toggleModal('dre', false)}
                    zIndex={zIndices.dre}
                    onFocus={() => focusModal('dre')}
                />
            )}

            {(modals.livroRazao || mounted.livroRazao) && (
                <LivroRazaoModal
                    visible={modals.livroRazao}
                    title={wrapTitle("Livro Razão", 'livroRazao')}
                    contaId={contaSelecionada}
                    contexto={razaoAbertoPor}
                    competencia={filterType === "mensal" ? mesCompetencia : null}
                    periodo={filterType === "periodo" ? periodo : null}
                    onClose={() => toggleModal('livroRazao', false)}
                    onSaved={fetchBalancete}
                    zIndex={zIndices.livroRazao}
                    zIndices={zIndices}
                    onFocus={() => focusModal('livroRazao')}
                    focusModal={focusModal}
                />
            )}

            {(modals.editLancamento || mounted.editLancamento) && (
                <EditLancamento
                    visible={modals.editLancamento}
                    title={wrapTitle("Lançamento Contábil", 'editLancamento')}
                    lancamentoId={editingLancamentoId}
                    competencia={filterType === "mensal" && mesCompetencia ? mesCompetencia.format("MM/YYYY") : null}
                    periodoFechado={periodoFechado}
                    onSaved={() => {
                        fetchBalancete();
                        toggleModal('editLancamento', false);
                    }}
                    onClose={() => toggleModal('editLancamento', false)}
                    zIndex={zIndices.editLancamento}
                    onFocus={() => focusModal('editLancamento')}
                />
            )}

            {(modals.lancamentosBancarios || mounted.lancamentosBancarios) && (
                <LancamentosBancarios
                    visible={modals.lancamentosBancarios}
                    title={wrapTitle("Conciliação Bancária", 'lancamentosBancarios')}
                    onClose={() => toggleModal('lancamentosBancarios', false)}
                    onUpdate={fetchBalancete}
                    zIndex={zIndices.lancamentosBancarios}
                    onFocus={() => focusModal('lancamentosBancarios')}
                />
            )}

            {(modals.balanco || mounted.balanco) && (
                <BalancoModal
                    visible={modals.balanco}
                    title={wrapTitle("Balanço Patrimonial", 'balanco')}
                    periodo={periodo}
                    onClose={() => toggleModal("balanco", false)}
                    onOpenInforme={() => toggleModal("informe", true)}
                    onUpdate={fetchBalancete}
                    onPeriodoFechado={() => {
                        if (periodo && periodo.length === 2) {
                            consultarMesesBloqueados(periodo[0], periodo[1]);
                        }
                        fetchBalancete();
                    }}
                    zIndex={zIndices.balanco}
                    onFocus={() => focusModal('balanco')}
                />
            )}

            {(modals.pagamentos || mounted.pagamentos) && <PagamentosModal visible={modals.pagamentos} title={wrapTitle("Consulta Pagamentos", 'pagamentos')} periodo={periodo} onClose={() => toggleModal('pagamentos', false)} zIndex={zIndices.pagamentos} onFocus={() => focusModal('pagamentos')} />}
            {(modals.contas || mounted.contas) && <ModalContasContabeis visible={modals.contas} title={wrapTitle("Plano de Contas", 'contas')} onClose={() => toggleModal('contas', false)} zIndex={zIndices.contas} onFocus={() => focusModal('contas')} />}
            {(modals.excel || mounted.excel) && (<ModalExcel show={modals.excel} title={wrapTitle("Importar Excel", 'excel')} handleClose={() => toggleModal('excel', false)} onUpdate={fetchBalancete} zIndex={zIndices.excel} onFocus={() => focusModal('excel')} />)}
            {(modals.delete || mounted.delete) && (<ModalDeletePeriod show={modals.delete} title={wrapTitle("Excluir Período", 'delete')} handleClose={() => toggleModal('delete', false)} onUpdate={fetchBalancete} zIndex={zIndices.delete} onFocus={() => focusModal('delete')} />)}
            {(modals.regerar || mounted.regerar) && (<ModalRegeneratePeriod show={modals.regerar} title={wrapTitle("Regerar Período", 'regerar')} handleClose={() => toggleModal('regerar', false)} onUpdate={fetchBalancete} zIndex={zIndices.regerar} onFocus={() => focusModal('regerar')} />)}
            {(modals.bloqueio || mounted.bloqueio) && (<ModalBloquearPeriodo show={modals.bloqueio} title={wrapTitle("Bloquear Período", 'bloqueio')} handleClose={() => toggleModal('bloqueio', false)} onUpdate={() => { fetchBalancete(); consultarPeriodoFechado(); }} zIndex={zIndices.bloqueio} onFocus={() => focusModal('bloqueio')} />)}
            {(modals.deletarBloqueio || mounted.deletarBloqueio) && (<ModalRemoverBloqueio show={modals.deletarBloqueio} title={wrapTitle("Desbloquear Período", 'deletarBloqueio')} handleClose={() => toggleModal('deletarBloqueio', false)} onUpdate={() => { fetchBalancete(); consultarPeriodoFechado(); }} zIndex={zIndices.deletarBloqueio} onFocus={() => focusModal('deletarBloqueio')} />)}
            {(modals.zeramento || mounted.zeramento) && (<ModalZerarPeriodo show={modals.zeramento} title={wrapTitle("Zeramento de Período", 'zeramento')} handleClose={() => toggleModal('zeramento', false)} onUpdate={() => { fetchBalancete(); consultarPeriodoFechado(); }} zIndex={zIndices.zeramento} onFocus={() => focusModal('zeramento')} />)}
            {(modals.informe || mounted.informe) && (
                <ModalInforme
                    open={modals.informe}
                    title={wrapTitle("Informe de Rendimentos", 'informe')}
                    onClose={() => toggleModal("informe", false)}
                    balancete={situacaoList}
                    pendenciaFiscal={defisPendencia}
                    onUpdate={fetchBalancete}
                    zIndex={zIndices.informe}
                    onFocus={() => focusModal('informe')}
                />
            )}
            {(modals.exportExcel || mounted.exportExcel) && (
                <ModalExportarExcel
                    visible={modals.exportExcel}
                    title={wrapTitle("Exportar Lançamentos", 'exportExcel')}
                    initialPeriod={periodo}
                    onClose={() => toggleModal('exportExcel', false)}
                    zIndex={zIndices.exportExcel}
                    onFocus={() => focusModal('exportExcel')}
                />
            )}

            {(modals.faturamento || mounted.faturamento) && (
                <ModalFaturamento
                    visible={modals.faturamento}
                    faturamentoData={faturamentoData}
                    title={wrapTitle(
                        <Space size="middle">
                            <div style={{
                                width: 32, height: 32, borderRadius: 8,
                                background: 'linear-gradient(135deg, #0361a7 0%, #02457a 100%)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff'
                            }}>
                                <BarChartOutlined />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.4' }}>
                                <span style={{ fontWeight: 700 }}>Consulta Faturamento</span>
                                <small style={{ fontWeight: 400, fontSize: '11px', color: '#64748b' }}>Extrato do Simples Nacional consolidado</small>
                            </div>
                        </Space>,
                        'faturamento'
                    )}
                    onClose={() => toggleModal('faturamento', false)}
                    onMinimize={() => minimizeModal('faturamento')}
                    zIndex={zIndices.faturamento}
                    onFocus={() => focusModal('faturamento')}
                />
            )}

            {(modals.folha || mounted.folha) && (
                <ModalFolha
                    visible={modals.folha}
                    title={wrapTitle("Informações da Folha", 'folha')}
                    onClose={() => toggleModal('folha', false)}
                    zIndex={zIndices.folha}
                    onFocus={() => focusModal('folha')}
                />
            )}

            {(modals.patrimonio || mounted.patrimonio) && (
                <ModalPatrimonio
                    visible={modals.patrimonio}
                    title={wrapTitle(
                        <Space>
                            <BuildOutlined />
                            <div style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: '1.2' }}>
                                <span>Controle de Patrimônio</span>
                                <small style={{ fontWeight: 400, fontSize: '11px', opacity: 0.8 }}>Gestão de imobilizado e depreciação</small>
                            </div>
                        </Space>,
                        'patrimonio'
                    )}
                    onClose={() => toggleModal('patrimonio', false)}
                    zIndex={zIndices.patrimonio}
                    onFocus={() => focusModal('patrimonio')}
                />
            )}

            {(modals.dashboard || mounted.dashboard) && (
                <ContabilidadeDashboard
                    visible={modals.dashboard}
                    title={wrapTitle("Dashboard de Gestão Contábil", 'dashboard')}
                    onClose={() => toggleModal('dashboard', false)}
                    zIndex={zIndices.dashboard}
                    onFocus={() => focusModal('dashboard')}
                />
            )}
        </>
    );
}
